<template>
  <div class="login justify-content-center py-5">
    <div class="login-card d-flex bg-white border rounded overflow-hidden">
      <div v-if="!user.id" class="p-5 flex-grow-1">
        <h1>Log In</h1>
        <h4 v-if="$route.params.message" class="mb-3">
          Sign in {{ $route.params.message }}
        </h4>
        <p v-else class="text-muted">Sign in to your account</p>
        <keep-alive>
          <LoginForm />
        </keep-alive>
      </div>
      <div v-else-if="showPasswordChange" class="p-5 flex-grow-1">
        <h1>Change Password</h1>
        <div class="mb-3">
          Your organization requires that you change your password every 90
          days. Please change it now.
        </div>
        <PasswordChangeForm />
      </div>
      <div v-else-if="show2FA" class="p-5 flex-grow-1">
        <h1>2FA</h1>
        <div class="mb-3">
          Two Factor Authentication is required for your organization. Please
          enable it now.
        </div>
        <b-button v-b-modal.tfa-setup variant="primary" size="lg" block>
          Enable 2FA now
        </b-button>
        <Setup2FA />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import LoginForm from "@/components/LoginForm";
import PasswordChangeForm from "@/components/PasswordChangeForm";
import Setup2FA from "@/components/2fa/Setup2FA";

export default {
  components: {
    LoginForm,
    PasswordChangeForm,
    Setup2FA
  },

  metaInfo: {
    titleTemplate: "Log In - %s"
  },

  data: () => ({
    show2FA: false,
    showPasswordChange: false
  }),

  computed: {
    ...mapState(["user"])
  },

  watch: {
    user: {
      handler(user) {
        if (user.require_2fa) {
          this.show2FA = true;
        } else if (user.require_password_change) {
          this.showPasswordChange = true;
        } else if (user.id) {
          const redirectPath = this.$route.query.goto
            ? decodeURIComponent(this.$route.query.goto)
            : "/dashboard";
          delete this.$route.query.goto;
          delete this.$route.query.auth;

          this.$router.replace({
            path: redirectPath,
            query: this.$route.query
          });
        }
      },
      deep: true,
      immediate: true
    }
  },

  created() {
    if (!this.user.id && this.$route.query.auth) {
      const data = { token: { value: this.$route.query.auth } };
      this.$store.commit("user/PATCH_USER", data);
      this.$store.dispatch("user/restoreSession");
    }
  }
};
</script>

<style lang="scss" scoped>
.login-card {
  max-width: 400px;
  margin: 0 auto;
}
</style>
